import belltechDefaults from '../tkhuby6608-1/config.js';

const isPDP = window.location.pathname.startsWith('/products/');

const baseFitmentFields = belltechDefaults.fitmentSearch.baseFields;
const extraFitmentFields = belltechDefaults.fitmentSearch.extraFields;

const doNotRedirectOnVehicleSelect =
  window.location.pathname === '/search/' ||
  document.querySelector('#product-listing-container-main.page-content--category, body.pages-product');

window.Convermax.getProductInformation = () => {
  const information = JSON.parse(window.Convermax.localStorage.getItem('cm_product_information'));

  if (information) {
    window.Convermax.localStorage.removeItem('cm_product_information');
    return information;
  }
};

window.Convermax.openProductInformationDialog = (product) => {
  window.Convermax.localStorage.setItem(
    'cm_product_information',
    JSON.stringify({
      id: product.id,
      name: product.name,
      sku: product.sku,
      mpn: product.mpn,
      description: product.description,
      price: formatPrice(product.price),
      category: product.category,
      FitmentType: product.FitmentType,
      Fitment: product.Fitment,
      comfort: product.comfort,
      handling: product.handling,
      ['height-adjustment']: product['height-adjustment'],
      ['everyday-use']: product['everyday-use'],
      ['track-performance']: product['track-performance'],
      /* eslint-disable camelcase */
      has_options: product.has_options,
      images_image_standard1: product.images_image_standard1,
      images_image_thumbnail1: product.images_image_thumbnail1,
      custom_url: product.custom_url,
      out_of_stock: product.out_of_stock,
      brand_name: product.brand_name,
      brand_url: product.brand_url,
      category_urls: product.category_urls,
      fitment_notes: product.Notes,
      /* eslint-enable camelcase */
    }),
  );

  window.Convermax.openDialog('ProductInformationDialog');
};

window.Convermax.getVehicleStringWithoutQualifires = (vehicle) =>
  [...baseFitmentFields, ...extraFitmentFields]
    .filter((field) => !field.startsWith('Qualifier_'))
    .map((f) => vehicle[f])
    .filter(Boolean)
    .join(' ');
window.Convermax.getVehicleExtraValues = (vehicle) =>
  extraFitmentFields
    .filter((field) => !field.startsWith('Qualifier_'))
    .map((f) => vehicle[f])
    .filter(Boolean);

function formatPrice(price) {
  if (!price) {
    return '';
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(price);
}

export default {
  ...belltechDefaults,
  includes: ['tkhuby6608-1'],
  sortFields: ['relevance', 'price', 'price:desc'],
  SearchRequestDefaults: {
    ...belltechDefaults.SearchRequestDefaults,
    extra: {
      ...belltechDefaults.SearchRequestDefaults.extra,
      ...(isPDP ? { productId: window.document.querySelector('input[name="product_id"]')?.value } : {}),
    },
  },
  Widgets: [
    ...belltechDefaults.Widgets.filter(
      (w) => !['SearchBoxMobile', 'HomeVehicleWidget', 'VehicleWidgetDialog'].includes(w.name),
    ),
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: {
        insertAfter: '[data-content-region="homepage_main"] site-hero',
      },
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 1000,
      isAlwaysActive: false,
    },
    {
      name: 'ProductInformationDialog',
      template: 'ProductInformationDialog',
      type: 'ContextDialog',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        replace: '.header-actions #quick-search-expand',
        class: 'cm-mobile-search-box navUser-action navUser-action--quickSearch',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      ...belltechDefaults.Widgets.find((widget) => widget.name === 'VehicleWidgetDialog'),
      doNotRedirectOnVehicleSelect,
    },
  ],
};
